export const listConstant = {
  childHeader: 'Tool Preventive Maintenance Plan list',
  addButtonLable: 'New Plan',
  datePickerLabel: 'Search By Year',
  modalTile: 'CREATE NEW PLAN',
};

export const createConstant = {
  childHeader: 'Tool Preventive Maintenance Plan list',
  theadHeader: ' Tool Preventive Maintenance Plan',
  extracolSpan: 2,
};

export const apiConstant = {
  // list api url
  gettableListDataurl: 'toolPreventiveMaintenancePlanNewRoute/monthlylist',
  deleteListurl: 'toolPreventiveMaintenancePlanNewRoute',
  getListPlanByid: 'toolPreventiveMaintenancePlanNewRoute',
  createListPlanByid: 'toolPreventiveMaintenancePlanNewRoute',

  // -----plan--
  sync: 'toolPreventiveMaintenancePlanNewRoute/handleSync',
  getAllPlanById: 'toolPreventiveMaintenancePlanNewRoute/allplansbyid',
  upadateCreateAllPlan:
    'toolPreventiveMaintenancePlanNewRoute/allplansCreateUpdate',
  maintenancePlanDeleteBulkById:
    'toolPreventiveMaintenancePlanNewRoute/maintenancePlanDeleteBulkById',
};

export const settingPanelConstant = {
  // settingPanel setting for plan
  crudApi: 'toolPreventiveMaintenancePlanNewSettingRoute',
  docType: 'toolPreventiveMaintenancePlanNew',
};

export const tilesConstant = {
  childHeaderText: 'Tool Preventive Maintenance Plan',
};

export const navigationConstant = {
  planRouter: '/common/toolPreventiveMaintenancePlanNewCreate',
};
